import clsx from 'clsx';
import React from 'react';

function sanitizeForHTMLId(id: string | undefined): string | undefined {
  // Remove any characters that are not letters, digits, hyphens, or underscores
  if (id === undefined) return undefined;
  const sanitizedId = id.replace(/[^a-zA-Z0-9-_]/g, '');

  // Ensure the ID starts with a letter
  const startsWithLetter = /^[a-zA-Z]/.test(sanitizedId);
  if (!startsWithLetter) {
    // If it doesn't start with a letter, prepend "id_" to the string
    return 'id_' + sanitizedId;
  }
  return sanitizedId;
}

type Props = {
  childrenTypeName: string | undefined;
  sectionId: string | undefined;
  theme: string;
  children?: React.ReactNode;
  marginBottom: number;
  marginTop: number;
  gridType: 'centered' | 'full';
  classes?: string;
};

const edgeToEdgeComponents = ['PackageSuggestionForm', 'Banner'];
const coverTopComponent = ['SinglePackageHeader', 'SinglePackageHeaderWithImage'];

const Section = ({
  childrenTypeName,
  sectionId,
  theme,
  children,
  marginBottom,
  marginTop,
  gridType,
  classes = '',
}: Props) => {
  let edgeToEdge = false;
  let coverTop = false;
  {
    if (childrenTypeName && edgeToEdgeComponents.includes(childrenTypeName)) edgeToEdge = true;
    if (childrenTypeName && coverTopComponent.includes(childrenTypeName)) coverTop = true;
  }
  return (
    <div
      className={clsx(
        classes,
        `md:pb-${marginBottom} pt-${marginTop} pb-${marginBottom / 2} bg-${theme}`,
        gridType === 'centered'
          ? 'col-span-8 col-start-1 sm:col-span-8 md:col-span-10 md:col-start-3 md:rounded-28'
          : 'col-span-8 sm:col-span-8 md:col-span-full',
        'grid w-full grid-cols-root gap-x-16 md:grid-cols-root-md md:gap-x-24',
        coverTop && 'relative'
      )}
    >
      <div
        id={sanitizeForHTMLId(sectionId)}
        className={clsx(
          'grid',
          !edgeToEdge
            ? 'col-span-12 px-16 md:col-start-2 md:px-0'
            : 'col-span-full grid-cols-root gap-x-16 md:grid-cols-root-md md:gap-x-24'
        )}
      >
        {children}
      </div>
    </div>
  );
};
export default Section;
